import { FocusEventHandler, useRef } from 'react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { useDeepCompareEffect } from './useDeepCompareEffect';

// This hook built to use inside the editable table (Table + RHF)
// When some elements rerender based on formState, current focusing input will be lost the cursor
// Put the custom handlers for onFocus and onBlur into the input will help to fix this issue
export const useTableInputCursor = <T extends FieldValues>() => {
  const ref = useRef<Path<T>>(null);
  const { formState, watch, setFocus } = useFormContext<T>();

  const values = watch();

  useDeepCompareEffect(() => {
    // formState.isDirty will trigger rerender to show/hide the ActionBar on the table
    // we need to keep focus on current input when formState.isDirty changes
    if (ref.current) {
      setFocus(ref.current as Path<T>);
    }
  }, [ref.current, formState.isDirty, values]);

  const handleInputFocus: FocusEventHandler<HTMLInputElement> = ({ target: { name } }) => {
    ref.current = name as Path<T>;
  };

  const handleInputBlur: FocusEventHandler<HTMLInputElement> = () => {
    ref.current = null;
  };

  return { handleInputBlur, handleInputFocus };
};
